import { render, staticRenderFns } from "./401.vue?vue&type=template&id=b66a57f6&scoped=true&"
import script from "./401.vue?vue&type=script&lang=js&"
export * from "./401.vue?vue&type=script&lang=js&"
import style0 from "./401.vue?vue&type=style&index=0&id=b66a57f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66a57f6",
  null
  
)

export default component.exports